export default "__VITE_ASSET__CSX_04Yd__"